import { render } from "./MsDropDownButton.vue?vue&type=template&id=9b7a7d72&scoped=true"
import script from "./MsDropDownButton.vue?vue&type=script&lang=js"
export * from "./MsDropDownButton.vue?vue&type=script&lang=js"

import "./MsDropDownButton.vue?vue&type=style&index=0&id=9b7a7d72&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b7a7d72"]])

export default __exports__